import React from 'react'

/**
 * The landing page of the admin gear. 
 *
 * @author Alex Clary
 * 
 * TODO: Rarely used and not very useful.
 */
const LandingPage = () =>
  <div className='admin-gear-landing-page'>
    <p>Welcome to the Admin Gear.</p>

    <p>The purpose of the Admin Gear is to administer LGY, by editing user accounts, managing external connections, checking incoming help tickets, and creating announcements.</p >
  </div>

export default LandingPage